import { CrosstalkFields } from './constants';
import { FieldMetadata } from '../fields/field-metadata';

export const crosstalkFieldMetadatas: FieldMetadata[] = [
    {
        agBand: null,
        alignment: 'left',
        canAggregate: false,
        canPivotOn: false,
        datatype: 'string',
        description: 'Number of latest comments by HedgeServ and client users',
        displayName: CrosstalkFields.CommentCounter,
        displayType: 'string',
        editable: false,
        format: null,
        hierarchy: 'Conversable Type Attributes',
        isAttribute: true,
        isDynamic: false,
        isFilterable: false,
        isOrdinal: false,
        name: CrosstalkFields.CommentCounter,
        zeroIfNone: false,
    },
    {
        agBand: null,
        alignment: 'left',
        canAggregate: false,
        canPivotOn: true,
        datatype: 'string',
        description: 'Attachments add, download and view',
        displayName: CrosstalkFields.Attachments,
        displayType: 'string',
        format: null,
        editable: false,
        hierarchy: 'Conversable Type Attributes',
        isAttribute: true,
        isDynamic: false,
        isFilterable: false,
        isOrdinal: false,
        name: CrosstalkFields.Attachments,
        zeroIfNone: false,
    },
];
